// @mui
import { Theme, SxProps } from '@mui/material/styles';
import Button from '@mui/material/Button';
// config
import { useMsal } from '@azure/msal-react';
import { loginRequest } from 'src/authConfig';

// ----------------------------------------------------------------------

type Props = {
  sx?: SxProps<Theme>;
};

export default function LoginButton({ sx }: Props) {
  const { instance } = useMsal();

  async function handleLogin() {
    try {
      await instance.loginPopup(loginRequest);
    } catch (ee) {
      console.error('ee', ee);
    }
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // Keep the user on the page they logged in from (e.g. New Worlds Reading)
    // instead of navigating them to the generic Data Lagoon home.
    event.preventDefault();
    handleLogin();
  };

  return (
    <Button variant="outlined" sx={{ mr: 1, ...sx }} onClick={handleClick}>
      Login
    </Button>
  );
}
